import Image from 'next/image';
import React from 'react';

function CreatrTeamLetter() {
  return (
    <div className="w-full  relative h-screen ">
      <Image
        src="https://assets.getcreatr.com/sign-up/team-creatr-message.webp"
        alt="Creatr Team Letter"
        className="absolute object-cover bottom-0 right-0 w-full z-[1] h-full"
        height={500}
        width={500}
      />
    </div>
  );
}

export default CreatrTeamLetter;
